/*
 * Removes the grey backdrop Bootstrap 4 leaves behind when a jQuery pop-up disappears without `.modal('hide')`, e.g.
 * a <Link> or history.push inside the pop-up unmounts it: the page then stays under `.modal-backdrop`, with
 * `modal-open` and an inline `padding-right` still on <body>.
 * It works on the DOM only (no React, no router), so it keeps working across the React / router upgrades.
 * Delete this file, and its import in index.js, together with the jQuery pop-ups.
 */
import $ from "jquery";

/**
 * A shown backdrop is orphaned when nothing in the document keeps it alive: no Bootstrap modal that is open or
 * opening (judged by Bootstrap's own state, since the backdrop gets `.show` before the modal does), and no open
 * BootstrapModal from components/common/Modal, which has no `bs.modal` data and renders its own backdrop.
 * A backdrop that is fading out after a normal hide has no `.show`, so it is left for Bootstrap to remove.
 */
function removeOrphanedBackdrop() {
    if (!document.querySelector(".modal-backdrop.show")) {
        return;
    }

    const hasLiveBootstrapModal = $(".modal")
        .toArray()
        .some((modalElement) => {
            const modalInstance = $(modalElement).data("bs.modal");
            return Boolean(modalInstance && (modalInstance._isShown || modalInstance._isTransitioning));
        });
    const hasOpenOwnModal =
        $(".modal.show").filter((index, modalElement) => !$(modalElement).data("bs.modal")).length > 0;
    if (hasLiveBootstrapModal || hasOpenOwnModal) {
        return;
    }

    $(".modal-backdrop.show").remove();
    document.body.classList.remove("modal-open");
    document.body.style.paddingRight = "";
}

let cleanupFrame = null;

new MutationObserver((mutations) => {
    const hasRemovedNodes = mutations.some((mutation) => mutation.removedNodes.length > 0);
    if (!hasRemovedNodes || cleanupFrame !== null) {
        return;
    }
    cleanupFrame = requestAnimationFrame(() => {
        cleanupFrame = null;
        removeOrphanedBackdrop();
    });
}).observe(document.body, { childList: true, subtree: true });
